export default {
  version: 3,
  dateFull: '19 marca 2020',
  link: '/polityka-prywatnosci.pdf',
};
